import { CashRefundIcon } from './CashRefundIcon';

/**
 * author: Michael Richins
 * id EADBBD96-B2BD-4C31-969E-BFBA6DF519B1
 * name cash-refund
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cash-refund.svg
 * tags
 * - Banking 
 * - Currency 
 */
export const CashChargebackIcon = CashRefundIcon;
export default CashChargebackIcon